export default "__VITE_ASSET__D7M9CYvd__"